"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mixinRootDisposable = exports.mixinDisposable = exports.Disposable = exports.RootDisposable = void 0;
var dispose_trace_1 = require("./dispose-trace");
var dispose_marktrack_1 = require("./dispose-marktrack");
var disposable_store_1 = require("./disposable-store");
/**
 * 销毁对象的基类
 */
var PureDisposable = /** @class */ (function () {
    function PureDisposable() {
        this.disposedStore = new disposable_store_1.DisposableStore();
    }
    PureDisposable.prototype.dispose = function (trace) {
        this.disposedStore.dispose(trace);
    };
    PureDisposable.prototype._register = function (t) {
        if (t === this) {
            throw new Error('Cannot register a disposable on itself!');
        }
        return this.disposedStore.add(t);
    };
    return PureDisposable;
}());
/**
 * 根销毁对象
 */
var RootDisposable = /** @class */ (function (_super) {
    __extends(RootDisposable, _super);
    function RootDisposable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RootDisposable.prototype.dispose = function (trace) {
        var parentTrace = trace;
        var isNewTrace = false;
        if (!parentTrace) {
            var disposableId = this.constructor.name;
            parentTrace = dispose_trace_1.DisposeTrace.traceRoot(disposableId);
            isNewTrace = true;
        }
        _super.prototype.dispose.call(this, parentTrace);
        isNewTrace && parentTrace.stop();
    };
    RootDisposable.prototype._register = function (t) {
        return _super.prototype._register.call(this, t);
    };
    return RootDisposable;
}(PureDisposable));
exports.RootDisposable = RootDisposable;
/**
 * 普通销毁对象
 */
var Disposable = /** @class */ (function (_super) {
    __extends(Disposable, _super);
    function Disposable() {
        var _this = _super.call(this) || this;
        // 标记告警
        dispose_marktrack_1.trackDisposable(_this);
        return _this;
    }
    Disposable.prototype.dispose = function (trace) {
        dispose_marktrack_1.markTracked(this);
        _super.prototype.dispose.call(this, trace);
    };
    return Disposable;
}(PureDisposable));
exports.Disposable = Disposable;
/**
 * 如果需要销毁的业务类已经有其他基类，使用该mix。class B extends MixinDisposable(TBase)
 * @param TBase
 */
// eslint-disable-next-line func-names
exports.mixinDisposable = function (TBase) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, __spread(args)) || this;
            _this.disposedStore = new disposable_store_1.DisposableStore();
            dispose_marktrack_1.trackDisposable(_this);
            return _this;
        }
        class_1.prototype.dispose = function (trace) {
            dispose_marktrack_1.markTracked(this);
            this.disposedStore.dispose(trace);
        };
        class_1.prototype._register = function (u) {
            return this.disposedStore.add(u);
        };
        return class_1;
    }(TBase));
};
/**
 * 如果需要销毁的业务类已经有其他基类，使用该mix。class B extends MixinDisposable(TBase)
 * @param TBase
 */
// eslint-disable-next-line func-names
exports.mixinRootDisposable = function (TBase) {
    return /** @class */ (function (_super) {
        __extends(class_2, _super);
        function class_2() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.disposedStore = new disposable_store_1.DisposableStore();
            return _this;
        }
        class_2.prototype.dispose = function (trace) {
            dispose_marktrack_1.markTracked(this);
            var parentTrace = trace;
            var isNewTrace = false;
            if (!parentTrace) {
                var disposableId = this.constructor.name;
                parentTrace = dispose_trace_1.DisposeTrace.traceRoot(disposableId);
                isNewTrace = true;
            }
            this.disposedStore.dispose(parentTrace);
            isNewTrace && parentTrace.stop();
        };
        class_2.prototype._register = function (u) {
            return this.disposedStore.add(u);
        };
        return class_2;
    }(TBase));
};
//# sourceMappingURL=disposable-base.js.map